import axios from 'axios'
import qs from 'qs'

//axios.defaults.baseURL = process.env.VUE_APP_FRONTEND_API_BASE_URL

export default {
    get() {
        return axios.get('/api/announce').then(response => {
            return response.data
        })
    },
    getById(id) {
        return axios.get('/api/announce/' + id).then(response => {
            return response.data
        })
    },
    getByAnnounceTypeId(id) {
        return axios.get('/api/announce/type/' + id).then(response => {
            return response.data
        })
    },
    getByPredicate(predicate) {
        return axios.get('/api/announce/predicate', {
            params: predicate,
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        }).then(response => {
            return response.data
        })
    }
}